// home view actions
export const GET_HOME_DATA = "GET_HOME_DATA";
export const CLEAR_HOME_DATA = "CLEAR_HOME_DATA";
export const SET_HOME_JOBS = "SET_HOME_JOBS";
export const SET_ANNOUNCEMENTS = "SET_ANNOUNCEMENTS";

// job view actions
export const GET_JOB_LIST = "GET_JOB_LIST";
export const SET_JOB_LIST = "SET_JOB_LIST";
export const UPDATE_JOB_LIST = "UPDATE_JOB_LIST";
export const SET_JOB_LIST_CURSOR = "SET_JOB_LIST_CURSOR";
export const SET_JOB_SEARCH = "SET_JOB_SEARCH";
export const SET_SELECTED_JOB = "SET_SELECTED_JOB";
export const SET_ACTIVE_JOB_TYPE = "SET_ACTIVE_JOB_TYPE";
export const SET_FILTER_TYPE = "SET_FILTER_TYPE";
export const SET_SORT_DIRECTION = "SET_SORT_DIRECTION";
export const CLEAR_JOB_LIST_DATA = "CLEAR_JOB_LIST_DATA";
export const CLAIM_JOB_PHASE = "CLAIM_JOB_PHASE";
export const COMPLETE_JOB_PHASE = "COMPLETE_JOB_PHASE";
export const GET_PHASE_CONFIG_LIST = "GET_PHASE_CONFIG_LIST";
export const SET_PHASE_CONFIG_LIST = "SET_PHASE_CONFIG_LIST";
export const GET_JOB_PHASE_WORKFLOW_DEFINITIONS = "GET_JOB_PHASE_WORKFLOW_DEFINITIONS";
export const SET_JOB_PHASE_WORKFLOW_DEFINITIONS = "SET_JOB_PHASE_WORKFLOW_DEFINITIONS";
export const SHOW_CONFIRM_CLAIM_DIALOG = "SHOW_CONFIRM_CLAIM_DIALOG";
export const DESTROY_CONFIRM_CLAIM_DIALOG = "DESTROY_CONFIRM_CLAIM_DIALOG";
export const TOGGLE_INITIATE_WORK_DIALOG = "TOGGLE_INITIATE_WORK_DIALOG";
export const SHOW_ACTIVITY_NOTIFICATION = "SHOW_ACTIVITY_NOTIFICATION";
export const RESET_ACTIVITY_NOTIFICATION = "RESET_ACTIVITY_NOTIFICATION";
export const OPEN_JOB_EDITOR = "OPEN_JOB_EDITOR";
export const SET_JOB_TEST_TYPE = "SET_JOB_TEST_TYPE";
export const SET_SELECTED_FILTERS = "SET_SELECTED_FILTERS";
export const OPEN_EXTERNAL_JOB = "OPEN_EXTERNAL_JOB";
export const SET_EXTERNAL_JOB_URL = "SET_EXTERNAL_JOB_URL";
export const GET_PHASE_DIRECTIONS = "GET_PHASE_DIRECTIONS";

// drawers actions
export const SHOW_DETAILS_DRAWER = "SHOW_DETAILS_DRAWER";
export const DESTROY_DETAILS_DRAWER = "DESTROY_DETAILS_DRAWER";
export const SET_FILTERS_DRAWER_VISIBILITY = "SET_FILTERS_DRAWER_VISIBILITY";

// task list actions
export const GET_TASK_LIST = "GET_TASK_LIST";
export const UPDATE_TASK_LIST = "UPDATE_TASK_LIST";
export const SIGN_RESOURCE = "SIGN_RESOURCE";

//  FAQ view actions
export const GET_FAQ_LIST = "GET_FAQ_LIST";
export const SET_ACTIVE_FAQ_TYPE = "SET_ACTIVE_FAQ_TYPE";
export const CLEAR_FAQ_LIST = "CLEAR_FAQ_LIST";
export const SEARCH_FAQ = "SEARCH_FAQ";
export const SET_FAQ_LIST = "SET_FAQ_LIST";

// mask actions
export const SET_LOADING = "SET_LOADING";
export const SET_EXTERNAL_URL_LOADING = "SET_EXTERNAL_URL_LOADING";

// main actions
export const DISPLAY_ERROR_MESSAGE = "DISPLAY_ERROR_MESSAGE";

// mobile action
export const SET_IS_MOBILE = "SET_IS_MOBILE";

// tests actions
export const SET_ACTIVE_TEST_TYPE = "SET_ACTIVE_TEST_TYPE";
